import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/podcasts/$channelUid/")({
	beforeLoad: async ({ context, params }) => {
		if (context.isOnboarding) {
			throw redirect({ to: "/podcasts/$channelUid/onboarding", params });
		}

		throw redirect({ to: "/podcasts/$channelUid/statistics", params });
	},
});
